var _path, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWhiteboardStudioTab = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6042 2.66667C16.1217 2.66667 16.5417 3.08635 16.5417 3.60417V4.80851H14.6667V3.60417C14.6667 3.08635 15.0863 2.66667 15.6042 2.66667ZM26.6667 16C26.3968 15.9425 26.1175 15.9129 25.8322 15.9129H6.16784C5.8825 15.9129 5.60303 15.9425 5.33334 16V8.12102C5.33334 6.59859 6.48991 5.33333 7.95529 5.33333H24.0445C25.4766 5.33333 26.6667 6.56301 26.6667 8.12102V16ZM14.2479 27.1124L13.6229 28.9874H18.3605L17.7355 27.1124H14.2479ZM9.96663 32C9.28108 32 8.88924 31.3293 9.07723 30.7656L11.0535 24.8374H13.0299L10.856 31.3586C10.7254 31.7512 10.3592 32 9.96663 32ZM20.9297 24.8374H18.9536L21.1272 31.3586C21.2586 31.752 21.624 32 22.0166 32C22.6753 32 23.1023 31.3538 22.906 30.7656L20.9297 24.8374ZM5.47386 17.3333H26.5261C28.074 17.3333 29.3333 18.5296 29.3333 20C29.3333 21.4704 28.074 22.6667 26.5261 22.6667H5.47386C3.92602 22.6667 2.66667 21.4706 2.66667 20C2.66667 18.5296 3.92602 17.3333 5.47386 17.3333Z",
    fill: "var(--asset-gradient-id)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "whiteboard-gradient-top",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--asset-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--asset-bg-color)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "whiteboard-gradient-left",
    x1: 32,
    y1: 16,
    x2: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--asset-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--asset-bg-color)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhiteboardStudioTab, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whiteboard-studio-tab.1fb9a091.svg";
export { ForwardRef as ReactComponent };